import { useRef } from "react";
import { Box } from "@mui/material";
import { useJitsiMeet } from "../../Hooks/useJitsiMeet";

interface VideoCallRoomProps {
  domain: string;
  roomName: string;
  token: string;
  displayName: string;
  height?: string;
  onCallEnded: () => void;
}

export default function VideoCallRoom({
  domain,
  roomName,
  token,
  displayName,
  height = "100vh",
  onCallEnded,
}: VideoCallRoomProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useJitsiMeet({
    domain,
    roomName,
    jwt: token,
    displayName,
    containerRef,
    onCallEnded,
  });

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        height,
        "& iframe": {
          width: "100%",
          height: "100%",
          border: "none",
        },
      }}
    />
  );
}
